import {Typography} from "@mui/material";
import {FOOTER_DATA} from "../constants";

const InnField = () => {
  return (
    <Typography
      sx={{
        textAlign: {xxs: 'center', md: 'start'},
        fontFamily: '"Pragmatica Extended", Arial, sans-serif',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '110%',
        marginBottom: 2.5,
        flex: {md: '0 0 100%'}
      }}
    >
      {FOOTER_DATA.inn}
    </Typography>
  )
}

export default InnField;
